import logoSrc from '@/assets/images/logo.png'
import { useSettings } from '@/context/SettingsContext'
import { cn } from '@/utils/cn'

/**
 * Renders the Kiddo Corner brand mark.
 *
 *   variant="full"  — shows the entire PNG (bear + wordmark). Use in the
 *                     footer and on large hero areas.
 *   variant="mark"  — shows only the bear illustration, cropped via
 *                     object-position. Use in the navbar where vertical
 *                     space is tight and the wordmark would render tiny.
 *
 * The PNG already contains the typeset wordmark so we never reproduce it
 * with CSS — single source of truth for the brand.
 *
 * @param {{ variant?: 'mark'|'full', size?: number, className?: string }} props
 */
export function Logo({ variant = 'mark', size = 40, className }) {
  const { brandName } = useSettings()

  if (variant === 'full') {
    return (
      <img
        src={logoSrc}
        alt={brandName}
        className={cn('h-auto w-auto object-contain', className)}
        style={{ maxHeight: size * 2.5 }}
      />
    )
  }
  // Crop the PNG so only the bear illustration is visible (the wordmark
  // sits in the bottom third of the artwork).
  return (
    <span
      role="img"
      aria-label={brandName}
      className={cn('inline-block flex-shrink-0 bg-no-repeat', className)}
      style={{
        width: size,
        height: size,
        backgroundImage: `url(${logoSrc})`,
        backgroundSize: '160% auto',
        backgroundPosition: 'center 28%',
      }}
    />
  )
}
